import React, { useEffect } from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Drawer, Typography, Box } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { getCollectionAnalyticsAction } from 'src/reducers/course-collection/action'
import { Icon } from '@iconify/react'
import AnalyticsCard from 'src/components/analytics-card'
import { CoreButton } from 'src/components/core'
import {
  analyticsDrawerOpen,
  courseReportAction,
} from 'src/reducers/course/action'

const AnalyticsDrawer = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const drawerOpen = useSelector(state => state.course.analyticsDrawerOpen)
  const entity = useSelector(state => state.course.course)
  const handleAnalyticsDrawer = () => {
    dispatch(analyticsDrawerOpen())
  }
  const handleGetAnalytics = () => {
    dispatch(courseReportAction(entity.id))
  }

  const [analyticsData, setAnalyticsData] = React.useState()

  const collectionId = entity?.courseCollectionId

  useEffect(() => {
    if (collectionId) {
      dispatch(
        getCollectionAnalyticsAction(collectionId, entity.id, data => {
          setAnalyticsData(data)
        }),
      )
    }
  }, [collectionId])

  const data = [
    {
      cardName: 'Eligible learners',
      tooltipMessage:
        'Those eligible to access the content. If no gateway is used, everyone is eligible. If an email gateway is selected, only learners with confirmed emails are eligible. If a payment gateway is used, only learners who have paid are eligible. If access is restricted to specific users that you invite, then only they are eligible. For automation or integration, eligibility is determined by the permissions you set.',
      image: '/assets/analytics-badges/eligible_learners.png',
      value: analyticsData?.assigned == null ? 'All' : analyticsData.assigned,
    },
    {
      cardName: 'Engaged learners',
      tooltipMessage:
        'Those who have interacted with the content by completing at least one card. This subset of eligible learners has actively participated in the learning process, either partially or fully. Engagement can include proceeding to the next card or responding to a question.',
      image: '/assets/analytics-badges/engaged_learners.png',
      value: analyticsData?.engaged,
    },
    {
      cardName: 'Learners who completed',
      tooltipMessage:
        'Those who have fully engaged with and completed the entire content.',
      image: '/assets/analytics-badges/learners_who_completed.png',
      value: analyticsData?.completed,
    },
    {
      cardName: 'Learners with badges',
      tooltipMessage:
        'Those who have earned a badge as recognition based on your chosen criteria, such as completing a mini course or achieving a success threshold that you set within a mini course.',
      image: '/assets/analytics-badges/learners_with_badges.png',
      value: analyticsData?.badgeCount,
    },

    {
      cardName: 'Average success score',
      tooltipMessage:
        'This metric represents the average success score based on the quiz questions.',
      image: '/assets/analytics-badges/average_success_score.png',
      value:
        analyticsData?.averageScore == 'NaN'
          ? '-'
          : analyticsData?.averageScore,
    },
  ]

  return (
    <div>
      <Drawer
        variant="temporary"
        anchor="right"
        classes={{ paper: classes.drawer }}
        open={drawerOpen}
        onClose={() => handleAnalyticsDrawer()}
        onOpen={() => handleAnalyticsDrawer()}
        transitionDuration={{ enter: 700, exit: 700 }}
      >
        <div className={classes.list}>
          <Typography className={classes.tabList}>Analytics</Typography>
          <Box m={1}></Box>
          <div className={classes.container}>
            {data.map((item, index) => (
              <AnalyticsCard item={item} key={index} type="course" />
            ))}
          </div>
          <Box m={2}></Box>
          <div style={{ textAlign: 'center' }}>
            <CoreButton
              onClick={() => {
                handleGetAnalytics()
                handleAnalyticsDrawer()
              }}
              variant="contained"
              fullWidth
              color="primary"
              startIcon={<Icon icon="tabler:download" color="white" />}
            >
              Download Full Report{' '}
            </CoreButton>
          </div>
        </div>
      </Drawer>
    </div>
  )
}
export default withStyles(styles)(AnalyticsDrawer)
